import {useState} from 'react';
import GoodsReceiptListview from './GoodsReceiptListview';
import GoodsReceiptForm from './GoodsReceiptForm';
const GoodsReciept = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
    return (
      <>
        {fromIsShown ? (
          <GoodsReceiptForm addForm={setFromIsShown} update={upData}   sId={serviceId}/>
        ) : (
          <GoodsReceiptListview addForm={setFromIsShown} update={setUpData}   sId={setServiceId}/>
        )}
      </>
  )
}

export default GoodsReciept